import qahoy from "views_shared/app/javascript/scripts/qahoy";
import qapi from "views_shared/app/javascript/api";

const useProductUpdateApi = ({
  setIsUpdating,
  setGeneralError,
  setAsyncError,
  product,
  setOpenEditModal,
  silentReload,
}) => {
  const updateProduct = async (data, options = {}) => {
    const { closeModal = true } = options;

    const cleanData = () => {
      const newData = {};
      Object.keys(data).forEach((key) => {
        if (data[key]?.length === 0) {
          newData[key] = null;
        } else {
          newData[key] = data[key];
        }
      });

      return newData;
    };

    try {
      setIsUpdating(true);
      setGeneralError(null);

      qahoy.track("Products#updateProduct");

      const response = await qapi.products.updateById(product.id, cleanData());

      if (response.data) {
        if (closeModal) setOpenEditModal(null);
        await silentReload();
      } else {
        setGeneralError(response);
      }
    } catch (error) {
      setAsyncError(error);
    } finally {
      setIsUpdating(false);
    }
  };

  return { updateProduct };
};

export default useProductUpdateApi;
